export default "__VITE_ASSET__3B44tM1M__"